<template>
  <v-app class="app-dashboard">
    <v-layout wrap>
      <v-flex md3 xs6 class="div-main-chart">
        <v-card class="card-chart">
          <v-card-title class="pa-1 ma-1">Meta Total</v-card-title>
          <v-card-text>
            <div>Total:</div>
            <p class="display-1 text--primary">{{ cards.total_meta }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 xs6 class="div-main-chart">
        <v-card class="card-chart">
          <v-card-title class="pa-1 ma-1">Meta Efetivada</v-card-title>
          <v-card-text>
            <div>Total:</div>
            <p class="display-1 text--primary">{{ cards.total_cadastro }}</p>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 xs6 class="div-main-chart">
        <v-card class="card-chart">
          <v-card-title class="pa-1 ma-1"> % Realizado</v-card-title>
          <v-card-text class="text-center">
            <v-progress-circular
              class="mt-n5"
              :rotate="360"
              :size="85"
              :width="15"
              :value="cards.total_percentual"
              color="primary"
              >{{ cards.total_percentual }}%</v-progress-circular
            >
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 xs6 class="div-main-chart">
        <v-card class="card-chart">
          <v-card-title class="pa-1 ma-1">Cad.Quebrados</v-card-title>
          <v-card-text>
            <div>Total:</div>
            <p
              style="cursor: pointer"
              class="display-1 text--primary"
              @click="getReportQuebrados(select_equipe)"
            >
              {{ cards.total_quebra }}
            </p>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex lg12 md12 xs12>
        <v-data-table
          :headers="headers"
          :items="itemsWithIndex"
          :search="search"
          :fixed-header="true"
          :items-per-page="-1"
          class="elevation-3"
          height="50vh"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Lista de Candidatos</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                class="mr-10"
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>

              <v-btn
                title="Atualizar os Dados"
                color="primary"
                rounded
                small
                @click="atualizarDados()"
              >
                <v-icon> mdi-refresh </v-icon>
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:item.percentual="{ item }">
            {{ item.percentual }} %
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
              class="mr-2"
              style="cursor: pointer"
              @click="
                detalheAssessor(item.id, item.nome_completo);
                getMetas(item.id);
              "
              >mdi-eye</v-icon
            >
          </template>
        </v-data-table>

        <v-dialog v-model="dialog_apuracao" max-width="500">
          <v-card>
            <v-card-title class="headline"> Apuração Final </v-card-title>

            <v-card-text>
              <v-select
                v-model="selects.apuracao.value"
                class="pa-1 mt-10"
                :items="selects.apuracao.items"
                outlined
                label="Tipo de Apuração"
                height="10"
                item-value="id"
                item-text="descricao"
              ></v-select>
              <v-select
                v-if="selects.apuracao.value > 2"
                v-model="selects.candidatos_metas.value"
                class="pa-1 mt-0"
                :items="selects.candidatos_metas.items"
                outlined
                label="Equipe"
                height="10"
                item-value="idcandidato"
                item-text="nome_completo"
                multiple
              ></v-select>

              <v-select
                v-if="selects.apuracao.value < 3"
                v-model="select_meta"
                class="pa-1 mt-0"
                :items="selects.metas.items"
                outlined
                label="Tipo de Meta"
                height="10"
                item-value="idmeta"
                item-text="descricao"
              ></v-select>

              <v-select
                v-if="selects.apuracao.value > 2"
                v-model="select_meta_cruzada"
                class="pa-1 mt-0"
                :items="selects.metas_cruzadas.items"
                outlined
                label="Metas"
                height="10"
                item-value="idmeta"
                item-text="descricao"
              ></v-select>

              <v-select
                v-if="selects.apuracao.value > 2"
                v-model="selects.tipo_ordenacao.value"
                class="pa-1 mt-0"
                :items="selects.tipo_ordenacao.items"
                outlined
                label="Tipo Ordenação"
                height="10"
                item-value="id"
                item-text="descricao"
              ></v-select>

              <v-btn
                v-if="selects.apuracao.value < 3"
                block
                style="margin-bottom: 20px"
                @click="getReportApuracaoAssessor(id_assessor)"
              >
                Apuração por Assessor
              </v-btn>

              <v-btn
                v-if="selects.apuracao.value < 3"
                block
                style="margin-bottom: 20px"
                @click="getReportApuracaoMeta(id_assessor)"
              >
                Apuração por Metas
              </v-btn>

              <v-btn
                v-if="selects.apuracao.value > 2"
                block
                @click="getReportApuracaoMetaCruzada(id_assessor)"
              >
                Processar
              </v-btn>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="dialog_apuracao = false"
              >
                SAIR
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout justify-center>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card style="padding: 0% 0% 1% 0%">
          <v-toolbar dark color="#216b80">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Listagem dos Assessores</v-toolbar-title>
          </v-toolbar>
          <v-layout style="padding: 1% 1% 1% 1%">
            <v-data-table
              :headers="headers_assessor"
              :items="itemsAssessorWithIndex"
              :fixed-header="true"
              height="70vh"
              :hide-default-footer="false"
              :items-per-page="-1"
              class="elevation-2"
              :search="search"
              item-key="id"
              style="width: 100%"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  EQUIPE :{{ assessor }}
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisa"
                    single-line
                    hide-details
                    clearable
                    v-lazy-input:debounce="500"
                    class="pl-10 pr-10"
                    style="max-width: 650px"
                  ></v-text-field>

                  <v-btn
                    color="warning"
                    small
                    rounded
                    title="Apuração Final"
                    style="margin-left: 20px"
                    @click="dialog_apuracao = true"
                  >
                    <v-icon> mdi-tray-full</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>

              <template v-slot:item.percentual="{ item }">
                {{ item.percentual }} %
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                  class="mr-2"
                  style="cursor: pointer"
                  @click="getReportAssessor(item.id)"
                  >mdi-printer</v-icon
                >
              </template>
            </v-data-table>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-app>
</template>
<script>
import DashboardAPI from "./../../api/dashboard";
import AclAPI from "./../../api/acl";
import VueLazyInput from "vue-lazy-input";
import Vue from "vue";

Vue.use(VueLazyInput);

export default {
  data() {
    return {
      dialog: false,
      dialog_apuracao: false,
      search: "",
      assessor: "",
      id_assessor: 0,
      cards: {
        total_meta: 0,
        total_cadastro: 0,
        total_percentual: 0,
        total_quebra: 0,
      },
      select_equipe: 0,
      select_meta: 0,
      select_meta_cruzada: 0,
      selects: {
        candidatos: {
          ativado: false,
          value: 0,
          items: [],
        },
        candidatos_metas: {
          value: [],
          items: [],
        },
        metas: {
          value: 0,
          items: [],
        },
        metas_cruzadas: {
          value: 0,
          items: [],
        },
        apuracao: {
          value: 1,
          items: [
            {
              id: 1,
              descricao: "CRUZAMENTO GERAL",
            },
            {
              id: 2,
              descricao: "CRUZAMENTO META",
            },
            {
              id: 3,
              descricao: "CRUZAMENTO ENTRE EQUIPES",
            },
          ],
        },
        tipo_ordenacao: {
          value: 0,
          items: [
            {
              id: 0,
              descricao: "PONTUACAO GERAL",
            },
            {
              id: 1,
              descricao: "PONTUACAO META",
            },
          ],
        },
      },
      headers: [
        { text: "Índice", value: "index" },
        {
          text: "Equipe",
          align: "start",
          value: "equipe",
        },
        {
          text: "Nome Completo",
          align: "start",
          value: "nome_completo",
        },
        { text: "Meta", value: "total_geral_meta" },
        { text: "Total de Cadastrados", value: "total_cadastrado" },
        { text: "Percentual Meta", value: "percentual" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      desserts: [],
      headers_assessor: [
        { text: "Índice", value: "index" },
        {
          text: "Equipe",
          align: "start",
          value: "equipe",
        },
        {
          text: "Nome Completo",
          align: "start",
          value: "nome_completo",
        },
        { text: "Meta", value: "total_geral_meta" },
        { text: "Total de Cadastrados", value: "total_cadastrado" },
        { text: "Percentual Meta", value: "percentual" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      desserts_assessor: [],
    };
  },
  computed: {
    setarEquipe() {
      const equipe = localStorage.getItem("equipe");
      return equipe;
    },
    itemsWithIndex() {
      return this.desserts.map((items, index) => ({
        ...items,
        index: index + 1,
      }));
    },
    itemsAssessorWithIndex() {
      return this.desserts_assessor.map((items, index) => ({
        ...items,
        index: index + 1,
      }));
    },
  },
  watch: {
    buscaCandidatos() {
      this.select_equipe = this.setarEquipe;
    },
  },

  created() {
    this.Helpers.verificarToken();
    this.buscaCandidatos();
    setTimeout(() => {
      this.setEquipe();
    }, 200);
    setTimeout(() => {
      this.buscarCandidatos();
      this.buscarTotais();
    }, 300);
  },
  methods: {
    buscaCandidatos() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.candidatos.items = [];
          this.selects.candidatos_metas.items = [];

          if (response.status == 200) {
            this.selects.candidatos.items = response.data.candidatos;
            this.selects.candidatos_metas.items = response.data.candidatos;

            let objCandidato = {
              idcandidato: "null",
              nome_completo: "TODAS",
              chapa: 0,
            };

            this.selects.candidatos.items.push(objCandidato);
            this.selects.candidatos_metas.items.push(objCandidato);
            //  this.selects.candidatos_metas.value = "null";
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    buscarTotais() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: this.select_equipe,
      };

      DashboardAPI.getTotais(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.cards.total_meta = response.data.totais[0].total_geral_meta;
          this.cards.total_cadastro = response.data.totais[0].total_cadastrado;
          this.cards.total_percentual = response.data.totais[0].percentual;
          this.cards.total_quebra = response.data.quebra[0].total;
        })
        .catch(() => {
          this.$store.dispatch("loading/habilitarLoading", false);
          this.Helpers.logout();
        });
    },
    buscarCandidatos() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getCandidatos(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts = response.data.candidatos;
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },

    buscarAssessores(id) {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: id,
        meta: this.select_meta,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getAssessores(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts_assessor = response.data.assessores;
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },

    detalheAssessor(id, assessor) {
      this.dialog = true;
      this.assessor = assessor;
      this.id_assessor = id;
      this.buscarAssessores(id);
    },

    getMetas(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
      };

      AclAPI.getMetas(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas.items = [];

          if (response.status == 200) {
            this.selects.metas.items = response.data.metas;

            let objMetas = {
              idmeta: "null",
              descricao: "TODAS",
            };

            this.selects.metas.items.push(objMetas);
            this.select_meta = "null";

            this.getMetasCruzada();
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    getMetasCruzada() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {};

      AclAPI.getMetasCruzada(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas_cruzadas.items = [];

          let objMetas = {
            idmeta: "null",
            descricao: "TODAS",
          };

          if (response.status == 200) {
            this.selects.metas_cruzadas.items = response.data.metas;
            this.selects.metas_cruzadas.items.push(objMetas);
            this.select_meta_cruzada = 5;
            this.selects.metas_cruzadas.value = 5;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    getReportAssessor(id) {
      const equipe = localStorage.getItem("id");
      let url = "relatorio_assessores?id=" + id + "&id_cd=" + equipe;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportQuebrados(id) {
      let url = "relatorio_quebrados?id=" + id;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportApuracaoAssessor(id) {
      let url =
        "relatorio_apuracao?equipe=" +
        id +
        "&meta=" +
        this.select_meta +
        "&tipo=" +
        2 +
        "&tipo_apuracao=" +
        this.selects.apuracao.value;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportApuracaoMeta(id) {
      let url =
        "relatorio_apuracao?equipe=" +
        id +
        "&meta=" +
        this.select_meta +
        "&tipo=" +
        1 +
        "&tipo_apuracao=" +
        this.selects.apuracao.value;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    getReportApuracaoMetaCruzada(id) {
      let url =
        "relatorio_apuracao_cruzado?equipe=" +
        this.selects.candidatos_metas.value +
        "&meta=" +
        this.select_meta_cruzada +
        "&tipo=" +
        1 +
        "&ordem=" +
        this.selects.tipo_ordenacao.value;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    setEquipe() {
      const equipe = localStorage.getItem("equipe");

      if (equipe != "null") {
        this.select_equipe = parseInt(equipe);
        this.selects.candidatos.ativado = true;
        this.getMetas(equipe);
      } else {
        this.select_equipe = "null";
        this.getMetas("null");
      }
    },
    atualizarDados() {
      this.buscarCandidatos();
      this.buscarTotais();
    },
  },
};
</script>
<style scoped>
.app-dashboard {
  background-color: #e7e6eb;
  height: 160px;
}

.card-chart {
  border-radius: 5px;
  height: 110px;
}

.div-main-chart {
  padding: 0.5% 2% 2% 2%;
}
</style>
